import React, { useState, useEffect, useRef } from 'react';
import '../../styles/Alumni_Messaging/alumni_chat_area.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { BiDotsVerticalRounded, BiLeftArrowAlt, BiSend, BiLinkAlt } from 'react-icons/bi';
import {
    ChatItem,
    MessageBox,
    MeetingMessage,
    SystemMessage,
    MessageList,
    ChatList,
    Input,
    Button,
    Popup,
    Navbar,
    Sidebar,
    Dropdown,
    LocationMessage,
    Avatar,
} from 'react-chat-elements';
import 'react-chat-elements/dist/main.css';
import { BASE_URL } from '../../settings';
import { socket, get_uuid, get_inboxUsername } from './Alumni_Inbox';
import { displayToast } from '../../utilities';

export default function Alumni_ChatArea() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const messageListReferance = useRef();
    const inputReferance = useRef();
    const [messages, setMessages] = useState([]);
    const [message, setMessage] = useState();
    const { clientHeight, offsetHeight, scrollHeight } = document.body;

    const [sender_socketId, setSenderSocketId] = useState();
    const [receiver_socketId, setReceiverSocketId] = useState();

    const [allAlumniData, setAllAlumniData] = useState([]);
    const [uuid, setUuid] = useState();
    const [username, setUsername] = useState();
    const [email, setEmail] = useState();
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [githubLink, setGithubLink] = useState();
    const [linkedInLink, setLinkedInLink] = useState();
    const [facebookLink, setFacebookLink] = useState();
    const [twitterLink, setTwitterLink] = useState();
    const [about, setAbout] = useState();
    const [avatar, setAvatar] = useState();
    const [classYear, setClassYear] = useState();
    const [positionName, setPositionName] = useState();
    const [mobile, setMobile] = useState();
    const [alumniFound, setAlumniFound] = useState(false);

    useEffect(() => {
        document.querySelector('._3drDv')?.classList?.add('isMyprofile');
        scrollPageToBottom();

        socket.emit('get-inbox-messages', { uuid, alumni_uuid: get_uuid() });

        socket.on('inbox-messsages', (data) => {
            setMessages(data);
        });

        socket.emit('get-receiver-socket-id', uuid);
        socket.emit('get-sender-socket-id', get_uuid());

        socket.on('receiver-socket-id', (id) => {
            setReceiverSocketId(id);
        });
        socket.on('sender-socket-id', (id) => {
            setSenderSocketId(id);
        });
    }, [socket, receiver_socketId, sender_socketId, uuid]);

    useEffect(() => {
        return () => {
            document.querySelector('._3drDv.isMyprofile')?.classList?.remove('isMyprofile');
        };
    }, []);

    const scrollPageToBottom = () => {
        let messageContainer = document.querySelector(
            '.alumni-chat-area-container .messages-container'
        );

        if (messageContainer) {
            // scroll chat to end
            messageContainer.scrollTop =
                messageContainer.scrollHeight - messageContainer.clientHeight;
            messageContainer.scrollTop =
                messageContainer.scrollHeight - messageContainer.clientHeight;
        }
    };

    useEffect(() => {
        // scrollPageToBottom();

        if (socket) {
            socket.on('new-message', (data) => {
                displayToast('new message!');
                console.log('\nmessages:', [...messages, { ...data, position: 'left' }]);
                // setMessages([...messages, { ...data, position: 'left' }]);
                socket.emit('get-inbox-messages', { uuid, alumni_uuid: get_uuid() });
                scrollPageToBottom();
            });

            socket.emit('get-inbox-messages', { uuid, alumni_uuid: get_uuid() });

            socket.on('inbox-messsages', (data) => {
                // let temp_mgs = [];
                if (Array.isArray(data)) {
                    data.forEach((item) => {
                        item.position = item?.id === get_uuid() ? 'right' : 'left';
                        item.avatar = item?.id === get_uuid() ? null : item?.avatar;
                    });
                    setMessages(data);
                } else {
                    setMessages([]);
                }
            });
        }

        let path = window.location.pathname?.split('/');
        let id = path[path?.length - 1];

        if (state?.alumni) {
            setAlumniFound(true);

            // 👇️ extract data from passed in alumni data
            setAllAlumniData(state?.alumni);
            setUuid(state?.alumni?.uuid);
            setUsername(state?.alumni?.username);
            setEmail(state?.alumni?.email);
            setFirstName(state?.alumni?.firstName);
            setLastName(state?.alumni?.lastName);
            setGithubLink(state?.alumni?.githubLink);
            setLinkedInLink(state?.alumni?.linkedInLink);
            setFacebookLink(state?.alumni?.facebookLink);
            setTwitterLink(state?.alumni?.twitterLink);
            setAbout(state?.alumni?.about);
            setAvatar(state?.alumni?.avatar);
            setClassYear(state?.alumni?.classYear);
            setPositionName(state?.alumni?.positionName);
            setMobile(state?.alumni?.mobile);
        } else {
            // 👇️ fetch alumni by id
            fetch(`${BASE_URL}/alumni/read`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id }),
            })
                .then(async (response) => {
                    let data = await response.json();
                    setAlumniFound(true);

                    let fetched_alumni = data?.alumni;
                    setAllAlumniData(fetched_alumni);
                    setUuid(fetched_alumni?.uuid);
                    setUsername(fetched_alumni?.username);
                    setEmail(fetched_alumni?.email);
                    setFirstName(fetched_alumni?.firstName);
                    setLastName(fetched_alumni?.lastName);
                    setGithubLink(fetched_alumni?.githubLink);
                    setLinkedInLink(fetched_alumni?.linkedInLink);
                    setFacebookLink(fetched_alumni?.facebookLink);
                    setTwitterLink(fetched_alumni?.twitterLink);
                    setAbout(fetched_alumni?.about);
                    setAvatar(fetched_alumni?.avatar);
                    setClassYear(fetched_alumni?.classYear);
                    setPositionName(fetched_alumni?.positionName);
                    setMobile(fetched_alumni?.mobile);
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true);
                        setAlumniFound(false);
                    } else {
                        displaySnackbar('Could not fetch alumni.', true);
                        setAlumniFound(false);
                    }
                });
        }
    }, []);

    // 👇️ handler when onReply button is clicked
    const onReplyButtonClicked = () => {
        let newMessage = {
            position: 'right',
            type: 'text',
            text: 'Lemme look into it.',
            date: new Date(),
            status: 'received',
            reply: {
                title: `@${username}`,
                titleColor: '#8717ae',
                message: 'Give me a message list example !',
            },
        };
        setMessages([...messages, newMessage]);
    };

    // 👇️ handler when send button is clicked
    const sendMessage = () => {
        if (
            (message && message?.trim() && message?.length > 0) ||
            (message == '0' && Number(0) != 0)
        ) {
            let newMessage = {
                position: 'right',
                type: 'text',
                text: message,
                date: new Date(),
                dateString: new Date().toTimeString().slice(0, 5),
                chatId: uuid, // receiver id ( talking to id )
                id: get_uuid(), // sender id (loggedin alumni )
                room: `room-@${username}`,
                avatar: avatar
                    ? `${BASE_URL}/alumni/uploads/get-profile-pic/${avatar}`
                    : require('../../images/profile-pictures/face2.jpg'),
            };

            socket.emit('new-message', {
                sender_socketId,
                receiver_socketId,
                newMessage,
            });
            setMessages([...messages, { ...newMessage, avatar: null }]);

            inputReferance.current.value = '';
            setMessage('');
            scrollPageToBottom();
        }
    };

    return (
        <div className='alumni-chat-area-container'>
            <Navbar
                left={
                    <>
                        <button
                            className='go-back-btn'
                            // onClick={() =>
                            //     navigate(`/alumni/inbox/${uuid}`, {
                            //         state: { alumni: allAlumniData },
                            //     })
                            // }
                            onClick={() => navigate(-1)}
                        >
                            {<BiLeftArrowAlt size={30} />}
                        </button>
                        <Avatar
                            src={
                                avatar
                                    ? `${BASE_URL}/alumni/uploads/get-profile-pic/${avatar}`
                                    : require('../../images/profile-pictures/face1.jpg')
                            }
                        />
                    </>
                }
                center={<span className='alumni-username'>@{username}</span>}
                right={
                    <Dropdown
                        title='Options'
                        animationType='default'
                        animationPosition='northeast'
                        buttonProps={{
                            text: <BiDotsVerticalRounded size={30} color='white' />,
                            backgroundColor: 'transparent',
                        }}
                        onSelect={(e) => {
                            console.log(e);
                        }}
                        items={[
                            {
                                text: 'Option 1',
                            },
                            {
                                text: 'Option 2',
                            },
                        ]}
                    />
                }
                type='dark'
                className='inbox-header'
            />

            {/* <SystemMessage text='Today' /> */}

            <div className='messages-container'>
                <MessageList
                    referance={messageListReferance}
                    className='message-list'
                    lockable={true}
                    toBottomHeight={'100%'}
                    onReplyClick={onReplyButtonClicked}
                    onRemoveMessageClick={() => {}}
                    onReplyMessageClick={() => {}}
                    dataSource={messages}
                />
            </div>

            <Input
                referance={inputReferance}
                placeholder='Message...'
                defaultValue={message}
                onChange={(e) => setMessage(e?.target?.value)}
                multiline={true}
                rightButtons={[
                    // <Button
                    //     color='black'
                    //     backgroundColor='transparent'
                    //     icon={{
                    //         float: 'right',
                    //         size: 25,
                    //         component: <BiLinkAlt />,
                    //     }}
                    // />,
                    // <Dropdown
                    //     title='Options'
                    //     animationType='default'
                    //     animationPosition='southeast'
                    //     buttonProps={{
                    //         text: <BiLinkAlt size={30} color='black' />,
                    //         backgroundColor: 'transparent',
                    //     }}
                    //     onSelect={(e) => {
                    //         console.log(e);
                    //     }}
                    //     items={[
                    //         {
                    //             text: 'Image',
                    //         },
                    //         {
                    //             text: 'Audio',
                    //         },
                    //     ]}
                    // />,
                    <Button
                        color='white'
                        backgroundColor='black'
                        onClick={sendMessage}
                        icon={{
                            float: 'right',
                            size: 30,
                            component: <BiSend />,
                        }}
                    />,
                ]}
            />
        </div>
    );
}
